// eslint-disable-next-line
import React, { useState, useEffect, useRef } from "react";
// eslint-disable-next-line
import {
  Link,
  Route,
  Routes,
  useParams,
  useNavigate,
  useLocation,
} from "react-router-dom";

import Students from "./Mapofallpasses/Mapofallpasses";

// eslint-disable-next-line
import { auth, firebase } from "../Firebase/config";
// eslint-disable-next-line
import {
  onSnapshot,
  orderBy,
  limit,
  collection,
  addDoc,
  query,
  where,
  getDocs,
  deleteDoc,
  doc,
  setDoc,
  getDoc,
  updateDoc,
  arrayUnion,
  FieldValue,
  getCountFromServer,
} from "@firebase/firestore";

import {
  admin,
  getAuth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendEmailVerification,
  onAuthStateChanged,
  deleteUser,
} from "@firebase/auth";
// eslint-disable-next-line
import NavBar from "./Navbar";

import "./Messages.css";

function App({ route, navigation }) {
  // eslint-disable-line no-unused-vars

  const { only2studentid, studentid, classid, language, role, id } = useParams();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [donotshow, setDonotshow] = useState();
  const [someoneisloggedin, setSomeoneisloggedin] = useState(false);
  const [id2, setId2] = useState();
  const [school2, setSchool2] = useState();
  const [town2, setTown2] = useState();
  const [state2, setState2] = useState();
  const [schoolid2, setSchoolid2] = useState();

  const [role2, setRole2] = useState();
  const [school, setSchool] = useState();
  const [todayspasses, setTodayspasses] = useState();

  const [lasttwomonths, setLasttwomonths] = useState([]);
  const [lasttwomonths2, setLasttwomonths2] = useState();

  const [selectedclass, setSelectedclass] = useState();

  const [updatesent, setUpdatesent] = useState();

  const [activename, setActivename] = useState("Active Passes");

  const [lastupdate, setLastupdate] = useState(0);
  const [selectedpass, setSelectedpass] = useState();
  const [idselected, setIdselected] = useState();
  const [currentstudentid, setCurrentsstudentid] = useState();
  const [arrayofstudentpasses, setArrayofstudentpassees] = useState();

  const [firstname, setFirstname] = useState();
  const [lastname, setLastname] = useState();
  const [studentname, setStudentname] = useState("");
  const [numberofdaysago, setNumberofdaysago] = useState();

  const [newdatestring, setNewdatestring] = useState();
   const [filteredstates, setFilteredstates] = useState([]);

  const auth = getAuth();

   const searchTimeoutRef = useRef(null);

  const location = useLocation();

  console.log(JSON.stringify(location.state), "123456");

  const getschoolid = async () => {

    try {
      const docRef = doc(firebase, "users", id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const userDoc = docSnap.data();

        setSchoolid2(userDoc.schoolid);

      } else {
        console.warn("⚠️ No document found in Firestore for user id:");
      }
    } catch (error) {
      console.error("❌ Error fetching user data from Firestore:", error);
    }

  };

  useEffect(() => {
    console.log("ID CHANGED", id);
    if (typeof id != "undefined") {
      getschoolid();
    }
  }, [id]);

  async function signout() {
    auth.signOut();
    setId2();
  }

  const onChanged1 = (text) => {
    setStudentname(text);

    // Clear any existing timeout
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    // Set a new timeout to update after 300ms of no typing
    searchTimeoutRef.current = setTimeout(() => {
      // This state update will trigger the useEffect in the child component
      setStudentname(text);
    }, 300);
  };

  const onChanged2 = (text) => {
    setNumberofdaysago(text);
  };

  useEffect(() => {
    if (typeof numberofdaysago != "undefined") {
      let today = Date.now();
      let newdate = new Date(today - (numberofdaysago * (1000 * 3600 * 24))).toString().substr(4, 11);

      setNewdatestring(newdate);
    }
  }, [numberofdaysago]);

  useEffect(() => {
    console.log(location.state, "You see this issn't there");
    if (location.state == null) {

      let aaa = localStorage.getItem("school");
      setSchool2(aaa);
      let bbb = localStorage.getItem("town"); // Remove JSON.parse
      setTown2(bbb);
      let ccc = localStorage.getItem("state"); // Remove JSON.parse
      setState2(ccc);
      // let ddd = JSON.parse(localStorage.getItem("schoolid"));
      // setSchoolid2(ddd);
      setNumberofdaysago(1);


    }
    else if (typeof location.state.id2 != "undefined") {

      setId2(location.state.id2);
      setSchool2(location.state.school2 || location.state.school);
      setTown2(location.state.town2 || location.state.town);
      setState2(location.state.state2 || location.state.state);  
      setSchoolid2(location.state.schoolid);


      setNumberofdaysago(1);
    } else {
      navigate("/SignIn");
    }
  }, []);

  useEffect(() => {
    if (
      typeof id2 != "undefined" &&
      typeof state2 != "undefined" &&
      typeof town2 != "undefined" &&
      typeof school2 != "undefined"
    ) {
      console.log("1234")
      if (school2 && town2 && state2) {
        getclasses();
      }
    }
  }, [id2, state2, town2, school2]);

  let now = Date.now();
  let twohours = 1000 * 60 * 60 * 2;

  let twohoursago = now - twohours;

  let sixtydays = 1000 * 60 * 60 * 24 * 60;
  let sixtydaysago = now - sixtydays;

  async function getclasses() {
    console.log("Getting passes from Firestore2345", school2, town2, state2, sixtydaysago);
    const q = query(
      collection(firebase, "passes"),
      where("school", "==", school2),
      where("town", "==", town2),
      where("state", "==", state2),
      where("timepassinitiated", ">", sixtydaysago),
      orderBy("timepassinitiated", "desc")
    );

    let allpasses = [];

    const querySnapshot = await getDocs(q).then(function (snapshot) {
      snapshot.forEach((doc) => {
        allpasses.push(doc.data());
      });

      localStorage.setItem("allpasses", JSON.stringify(allpasses));

      console.log(allpasses, "Is it finiding all passes.");

      const onpassnow = allpasses.filter((person) => {
        return person.leftclass > twohoursago && person.returned == 0;
      });

      console.log(onpassnow, "this is whatwasin on pass now.");

      localStorage.setItem("onpass", JSON.stringify(onpassnow));

      setTimeout(() => {
        let butter = Date.now();
        setUpdatesent(butter);
      }, 500);
    });
  }
// not safe onSnapshot, will run multiple times and create multiple listeners, which can lead to memory leaks and unexpected behavior. Use the safe onSnapshot with useEffect and cleanup below instead.

  // if (typeof schoolid2 != "undefined") {
  //   console.log("1234Setting up on snapshot");
  //   onSnapshot(doc(firebase, "schools", schoolid2), (doc) => {
  //     console.log("AAAAAAAAA", lastupdate, doc.data().update, "88888888888");
  //     if (typeof lastupdate != "undefined" || doc.data().update != lastupdate) {
  //       setLastupdate(doc.data().update);
  //     } else {
  //       console.log("Don't do anything");
  //     }
  //   });
  // }

  //safe onSnapshot with useEffect and cleanup

  useEffect(() => {
  // 1. SAFETY FILTER: Stop immediately if schoolid2 is missing or undefined
  if (typeof schoolid2 === "undefined" || !schoolid2) {
    return undefined; 
  }

  console.log("🟢 Setting up school onSnapshot safely inside useEffect");

  // 2. Build the document reference path
  const schoolDocRef = doc(firebase, "schools", schoolid2);

  // 3. Open the real-time Firebase listener
  const unsubscribe = onSnapshot(
    schoolDocRef, 
    (docSnap) => {
      // Safety step: Make sure the document actually exists in Firestore
      if (!docSnap.exists()) {
        console.log("⚠️ School document does not exist in the database.");
        return;
      }

      const snapData = docSnap.data() || {};
      
      console.log("AAAAAAAAA", lastupdate, snapData.update, "88888888888");

      // 4. KEEP YOUR LOGIC: Check if lastupdate is missing or if the DB value changed
      if (typeof lastupdate === "undefined" || snapData.update !== lastupdate) {
        setLastupdate(snapData.update);
      } else {
        console.log("Don't do anything");
      }
    },
    (error) => {
      console.error("🔴 School Snapshot Listener Failed:", error.message);
    }
  );

  // 5. CLEANUP FUNCTION: React calls this automatically before restarting the hook 
  // or when the user navigates away from the page, destroying the background listener.
  return () => {
    console.log("❌ Safely disconnecting school snapshot listener.");
    unsubscribe();
  };

  // 6. DEPENDENCY ARRAY: We watch schoolid2 and lastupdate so the comparison check 
  // always evaluates against the freshest values.
}, [schoolid2, lastupdate]); 


  useEffect(() => {
    if (typeof selectedpass != "undefined") {
      let idselect = selectedpass.id;
      let student = selectedpass.studentid;
      let fname = selectedpass.firstname;
      let lname = selectedpass.lastname;
      setIdselected(idselect);
      setCurrentsstudentid(student);
      setFirstname(fname);
      setLastname(lname);
    }
  }, [selectedpass]);

  useEffect(() => {
    if (typeof lastupdate != "undefined" && lastupdate > 0) {
      setTimeout(() => {
        getclasses();
      }, 1000);

    }
  }, [lastupdate]);

  // useEffect(
  //   () =>
  //     onSnapshot(doc(firebase, "schools", schoolid2), (doc) => {
  //       if (doc.data().update > 0) {
  //         getclasses();
  //       } else {
  //         console.log("Don't do anything");
  //       }
  //     }),
  //   []
  // );

  const navigate = useNavigate();

  const sections = [
    { Name: "Active Passes", key: 1 },
    { Name: "Search By Name", key: 2 },
    { Name: "Search By Date", key: 3 },
  ];

  async function signout() {
    auth.signOut();
    setId2();

    navigate("/");
  }

  useEffect(() => {
    setDonotshow(true);
  }, []);


  useEffect(() => {
    if (typeof selectedclass != "undefined") {
      setActivename(selectedclass.Name);
    }
  }, [selectedclass]);

  return (
    <div className="App22">
      <NavBar
        donotshow={donotshow}
        role={role}
        sections={sections}
        setSelectedclass={setSelectedclass}
        activename={activename}
      />
      <div className="App29">
        <header className="App-header">
          <div className="container222" style={{ width: "clamp(300px, 80vw, 400px); margin-left: auto; margin-right: auto;  " }}>
            <div className="section591abc123">
              {typeof idselected != "undefined" ? (
                <p className="section5922ab29">Selected Pass</p>
              ) : (
                <p className="section5922ab29">{activename}</p>
              )}

              <br />
              <br />
              {activename == "Search By Name" ? (
                <div>
                  <div className="field22abc">
                    <input
                      placeholder="Student Identifier"
                      value={studentname}
                      onChange={(e) => onChanged1(e.target.value)}
                      type="text"
                      style={{ paddingRight: studentname ? '30px' : '10px' }}
                    />
                    {studentname && (
                      <span
                        onClick={() => setStudentname('')}
                        style={{
                          position: 'absolute',
                          right: '10px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          cursor: 'pointer',
                          color: '#999'
                        }}
                      >
                        ✕
                      </span>
                    )}
                    {studentname && filteredstates && (
                      <small style={{ display: 'block', marginTop: '5px', color: '#666' }}>
                        {filteredstates.length === 0 ?
                          "No matches found" :
                          `Found ${filteredstates.length} matches`}
                      </small>
                    )}
                  </div>
                </div>
              ) : null}

              {activename == "Search By Date" ? (
                <div className="field22abc31">
                  {newdatestring}
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "12px", marginTop: "12px" }}>
                    <button
                      onClick={() => setNumberofdaysago(prev => Math.max(0, (prev || 0) - 1))}
                      style={{
                        width: "40px",
                        height: "40px",
                        fontSize: "24px",
                        fontWeight: "bold",
                        backgroundColor: "#013469",
                        color: "#fff",
                        border: "2px solid #E43522",
                        borderRadius: "6px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                      }}
                      onMouseOver={(e) => e.target.style.backgroundColor = "#0256a6"}
                      onMouseOut={(e) => e.target.style.backgroundColor = "#013469"}
                    >
                      ⬆︎
                    </button>
                 
                    <button
                      onClick={() => setNumberofdaysago(prev => (prev || 0) + 1)}
                      style={{
                        width: "40px",
                        height: "40px",
                        fontSize: "24px",
                        fontWeight: "bold",
                        backgroundColor: "#013469",
                        color: "#fff",
                        border: "2px solid #E43522",
                        borderRadius: "6px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                     
                      }}
                      onMouseOver={(e) => e.target.style.backgroundColor = "#0256a6"}
                      onMouseOut={(e) => e.target.style.backgroundColor = "#013469"}
                    >
                      ⬇︎
                    </button>
                  </div><br></br>
                  <p>Use Up/Down Buttons<br></br>to Adjust Date</p>
                </div>
              ) : null}

              <Students
                lasttwomonths={lasttwomonths}
                activename={activename}
                lasttwomonths2={lasttwomonths2}
                updatesent={updatesent}
                selectedpass={selectedpass}
                setSelectedpass={setSelectedpass}
                idselected={idselected}
                currentstudentid={currentstudentid}
                arrayofstudentpasses={arrayofstudentpasses}
                setArrayofstudentpassees={setArrayofstudentpassees}
                studentname={studentname} numberofdaysago={numberofdaysago}
                lastupdate={lastupdate}
                filteredstates={filteredstates}
                setFilteredstates={setFilteredstates}
              />


            </div>
          </div>
          {activename == "Active Passes" ? <div className="field229">
            <div className="innertext" onClick={() => signout()}>
              Sign Out
            </div>
          </div> : null}
        </header>
      </div>
    </div>
  );
}

export default App;
